// 医保支付——微信，主流程
const wxMainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `pay/wx/index${i + 1}`,
  name: `payWxIndex${i + 1}`,
  component: () => import(`@/views/health/pay/wx/index${i + 1}.vue`)
}))

// 医保支付——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `pay/zfb/index${i + 1}`,
  name: `payZfbIndex${i + 1}`,
  component: () => import(`@/views/health/pay/zfb/index${i + 1}.vue`)
}))

export default {
  path: '/health',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 医保支付——微信，开始
    ...wxMainRoutes,

    // 医保支付——支付宝，主流程
    ...zfbMainRoutes
  ]
}
